// Table column configurations for different monitor tables
import { DateTime } from "luxon"

export const pickerGroupsColumns = [
  { key: 'deviceGroupName', label: 'Group Name' },
  { key: 'blockName', label: 'Block Name' },
  { key: 'totalUnits', label: 'Total Units' },
  { key: 'weight', label: 'Weight (Kg)' },
  { key: 'totalWorkHours', label: 'Total work hours' },
  { key: 'activeWorkers', label: 'Active Workers' },
  { key: 'averagePerWorker', label: 'Average per worker' },
  { key: 'averageHourlyRatePerWorker', label: 'Average hourly rate per worker' }
]

export const pickerMonitorColumns = [
  { key: 'workerId', label: 'Worker ID' },
  { key: 'workerName', label: 'Worker Name' },
  { key: 'blockName', label: 'Block Name' },
  { key: 'deviceGroupName', label: 'Group Name' },
  { key: 'totalUnits', label: 'Total Units' },
  { key: 'totalWorkHours', label: 'Total work hours' },
  { key: 'averageRatePerHour', label: 'Average rate per hour' },
  { key: 'averageRatePerDay', label: 'Average rate per day' },
  { key: 'workerComments', label: 'Worker Comments' }
]

export const blockMonitorColumns = [
  { key: 'blockName', label: 'Block Name' },
  { key: 'crop', label: 'Crop' },
  { key: 'variety', label: 'Variety' },
  { key: 'totalScans', label: 'Total Scans' },
  { key: 'totalUnits', label: 'Total Units' },
  { key: 'weight', label: 'Weight (Kg)' },
  { key: 'kgPerPlant', label: 'KG/plant' },
  { key: 'kgPerSquareMeter', label: 'Kg/m²' }
]

export const agroGroupsMonitoringColumns = [
  { key: 'groupName', label: 'Group Name' },
  { key: 'blockName', label: 'Block Name' },
  { key: 'totalUnits', label: 'Total Units' },
  { key: 'totalWorkHours', label: 'Total work hours' },
  { key: 'activeWorkers', label: 'Active Workers' },
  { key: 'averagePerWorker', label: 'Average per worker' },
  { key: 'averageHourlyRatePerWorker', label: 'Average hourly rate per worker' }
]

export const agroActionsColumns = [
  { key: 'blockName', label: 'Block Name' },
  { key: 'activityName', label: 'Activity Name' },
  { key: 'units', label: 'Units' },
  {
    key: 'percentageCompletion',
    label: 'Percentage of completion',
    cell: (value) => {
      // Don't render the badge for empty values (like in totals row)
      if (!value || value === '') {
        return <span>{value}</span>
      }

      return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
          parseInt(value) === 100 ? 'bg-green-100 text-green-800' : parseInt(value) >= 50 ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'
        }`}
        >
          {value}
        </span>
      )
    }
  }
]

export const packerGroupsColumns = [
  { key: 'groupName', label: 'Group Name' },
  { key: 'totalPacked', label: 'Total Packed' },
  { key: 'workerCount', label: 'Worker Count' },
  { key: 'avgWeight', label: 'Avg Weight (Kg)' },
  { key: 'percentageOfTotal', label: 'Percentage of Total' },
  { key: 'avgPerWorker', label: 'Avg Per Worker' }
]

export const packerMonitorColumns = [
  { key: 'workerId', label: 'Worker ID' },
  { key: 'workerName', label: 'Worker Name' },
  { key: 'groupName', label: 'Group Name' },
  { key: 'totalPacked', label: 'Total Packed' },
  { key: 'percentageOfTotal', label: 'Percentage of Total' },
  { key: 'averagePacked', label: 'Average Packed' }
]

export const pickingColumns = [
  { key: 'blockName', label: 'Block Name' },
  { key: 'containerName', label: 'Container Name' },
  { key: 'totalCredits', label: 'Total Credits' },
  { key: 'totalContainers', label: 'Total Containers' }
]

export const pickingColumnsWithDate = [
  { key: 'blockName', label: 'Block Name' },
  { key: 'containerName', label: 'Container Name' },
  { key: 'totalCredits', label: 'Total Credits' },
  { key: 'totalContainers', label: 'Total Containers' },
  { key: 'date', label: 'Date', cell: (value) => {
    return value ? DateTime.fromISO(value).setZone('America/Mexico_City').toJSDate().toLocaleDateString('es-MX') : ''
  } }
]

export const packingColumns = [
  { key: 'containerName', label: 'Container Name' },
  { key: 'stickerType', label: 'Sticker Type' },
  { key: 'totalPacked', label: 'Total Packed' },
  { key: 'packerCount', label: 'Packer Count' }
]

export const packingColumnsWithDate = [
  { key: 'containerName', label: 'Container Name' },
  { key: 'stickerType', label: 'Sticker Type' },
  { key: 'totalPacked', label: 'Total Packed' },
  { key: 'packerCount', label: 'Packer Count' },
  { key: 'date', label: 'Date', cell: (value) => {
    return value ? DateTime.fromISO(value).setZone('America/Mexico_City').toJSDate().toLocaleDateString('es-MX') : ''
  } }
]
